export default {
  event_id: 136260030419,
  widget_type: 'checkout',
  iframe_container_height: 425,
  component: 'o-eventbrite-widget',
}
